import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {EStorageKeys} from 'src/constants';
import {TLeadFilters} from 'src/containers/LeadCompanyClients';
import {listenerMiddleware} from 'src/models';

const initialState = () => {
  const rememberedFilters = sessionStorage.getItem(EStorageKeys.AGENTS_CLIENTS_FILTERS);

  return {
    filters: rememberedFilters ? JSON.parse(rememberedFilters) : {},
  };
};

const agentClientsSlice = createSlice({
  name: 'agentClients',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<TLeadFilters>) {
      state.filters = action.payload;
    },
  },
});

export const {setFilters: setFiltersAction} = agentClientsSlice.actions;
export const selectFilters = (state: TRootState) => state.agentClients.filters as TLeadFilters;

listenerMiddleware.startListening({
  actionCreator: setFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(EStorageKeys.AGENTS_CLIENTS_FILTERS, JSON.stringify(action.payload));
  },
});

export default agentClientsSlice.reducer;
